type EnquiryResponseDevelopment<T> = {
  enquiry_response_override_lot?: boolean | null;
  email_templates?: readonly T[] | null;
};

type EnquiryResponseEmailTemplateSource<T> = {
  development: EnquiryResponseDevelopment<T> | null | undefined;
  listingTemplates: readonly T[] | null | undefined;
};

export const getEnquiryResponseEmailTemplate = <T>({
  development,
  listingTemplates,
}: EnquiryResponseEmailTemplateSource<T>) =>
  development?.enquiry_response_override_lot === true
    ? development.email_templates?.[0]
    : listingTemplates?.[0];
